import { styled } from '@mui/material/styles';
import { Typography } from '@components/Typography';
import UnverifiedBadge from '@components/UnverifiedBadge';
import { useTranslation } from '@hooks';
import { generateCompanyCardAddress } from '@helpers/companies';
import Card from '@components/Card';
import { BRAND_TEAL } from '@constants/colors';

const CardText = styled('p', {
    shouldForwardProp: prop => prop !== 'isDisabled' && prop !== 'isAccName',
})(({ isDisabled, isAccName }) => ({
    fontFamily: 'Rubik, sans-serif',
    fontWeight: 500,
    fontSize: 10,
    lineHeight: '12px',
    letterSpacing: '1.5px',
    textTransform: 'uppercase',
    color: 'var(--text-secondary)',
    marginTop: 0,
    ...(isDisabled && {
        color: 'var(--text-tertiary)',
    }),
    ...(isAccName && {
        color: 'var(--success-main)',
        marginBottom: 0,
    }),
}));

const GoogleCompanyCard = ({ location = {}, selectedCompanies, setCompany }) => {
    const { t } = useTranslation();
    const isActive = selectedCompanies.some(c => c.locationId === location.locationId);
    const isDisabled = location.connected;

    return (
        <Card
            type="checkbox"
            selected={isActive && !isDisabled}
            disabled={isDisabled}
            title={location.title}
            value={location.locationId}
            setValue={() => setCompany(location)}
        >
            {location.country && (
                <CardText isDisabled={isDisabled} style={{ marginBottom: '8px' }}>
                    {generateCompanyCardAddress(location)}
                </CardText>
            )}
            {location.primaryPhoneNumber && (
                <CardText isDisabled={isDisabled} style={{ marginBottom: location.company ? '16px' : 0 }}>
                    {location.primaryPhoneNumber}
                </CardText>
            )}
            {location.company && (
                <CardText isAccName>
                    {t('SettingsCompanies.linkedTo')}&nbsp;
                    {location.company?.name}
                </CardText>
            )}
            {isDisabled && (
                <Typography
                    variant="caption"
                    sx={{
                        color: '#fff',
                        backgroundColor: BRAND_TEAL,
                        padding: '2px 6px',
                        borderRadius: '18px',
                        width: 'fit-content',
                        marginTop: '16px',
                    }}
                >
                    {location.connectedLocationName}
                </Typography>
            )}
            {!isDisabled && !location.isVerified && <UnverifiedBadge />}
        </Card>
    );
};

export default GoogleCompanyCard;
